import { access as GratisHPAccess } from '../../services/wsGratisHP'
import userRoles from '../../globals/userRoles'

export const isTeacherRoleAsync = (userInfo) => {
  return new Promise(resolve => {
    resolve(userInfo && (userInfo.role === userRoles.TEACHER))
  })
}

// MBQ OCT 2025 RESTYLING
/*export const hasAccessToGratisHP = () => {
  return new Promise((resolve, reject) => {

    const callback = (error, data) => {
      if(error) return reject(error)
      return resolve(data.access === 0)
    }

    GratisHPAccess(callback)
  })
}*/
export const hasAccessToGratisHP = userInfo => {
  if(
    userInfo &&
    [userRoles.USER_INTERNAL, userRoles.TEACHER_FAKE].includes(userInfo.role)
  ) {
    return false
  }
  return new Promise((resolve, reject) => {
    const callback = (error, data) => {
      if(error) return reject(error)
      return resolve(data.access === 0)
    }

    GratisHPAccess(callback)
  })
}

export const hasGXA = (userInfo) => {
  return new Promise(resolve => {
    resolve(userInfo && userInfo.gpaPermission)
  })
}

export const isTeacherDemoAsync = (userInfo) => {
  return new Promise(resolve => {
    resolve(userInfo && (userInfo.role === userRoles.TEACHER_DEMO))
  })
}
